module.exports = __webpack_public_path__ + "img/point2_bgcircle06.a3116372.png";